import React from "react";
import BounceLoader from "react-spinners/SyncLoader";
import { css } from "@emotion/core";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: #0078ff;
  top: 50%;
  left: 50%;
  position: fixed;
  color: darkred;
  margin-top: -32px;
  margin-left: -32px;
`;

const Index = () => {
  return (
    <div
      className="loader"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 999999999,
      }}
    >
      <BounceLoader css={override} color={"#0078ff"} loading={true} />
    </div>
  );
};

export default Index;
